<app-breadcrumb [master]="'OCK'" [parentName]="'Import'"  [name]="'VIN '"></app-breadcrumb>
<div class="vin-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="vin-list-filters">
    <mat-form-field class="nip-list-filter">
      <mat-label>VIN</mat-label>
      <input matInput placeholder="VIN" name="contains$vin" [(ngModel)]="initialFilters.contains$vin">
    </mat-form-field>

  </form>

  <div class="vin-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="row">


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> VIN </th>
      <td mat-cell *matCellDef="let element">
        {{element.vin}}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="delete(element.uuid)" mat-button  color="warn"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

